module.exports = __webpack_public_path__ + "img/dat02.a10eb90b.png";